<template>
  <div
    class="content live-list"
    :class="{
      'electron-live-list': isElectron,
    }"
    v-loading.fullscreen.lock="pageLoading"
    element-loading-text="创建教室中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255,255,255,.6)"
  >
    <!-- tab -->
    <ul class="tabs-wrap">
      <li
        v-for="item in navList"
        :key="item.type"
        :class="{ active: item.type === activeId }"
        @click="changeTab(item.type)"
      >
        {{ item.name }}
      </li>
    </ul>
    <div class="live-list-cont">
      <div class="calendar">
        <my-calendar
          :markDate="markDate"
          @clickDay="handleClickDay"
          @showAllData="showAllData"
          @changeMonth="handleChangeMonth"
        ></my-calendar>
      </div>
      <div class="right-cont">
        <!-- 列表 -->
        <teacher-list
          class="list-comp"
          v-show="activeId === 0"
          :showList="teacherList"
          @goLiveRoom="goLiveRoom"
          @handleScroll="handleScroll"
          :showAll="showAll"
        />
        <assistant-list
          class="list-comp"
          v-show="activeId === 1"
          :showList="assistantList"
          @goLiveRoom="goLiveRoom"
          @handleScroll="handleScroll"
          :showAll="showAll"
        />
      </div>
      <!-- @createRooming="createRooming" -->
      <live-mode-dialog ref="liveMode" @success="handleSuccess" />
      <live-overview ref="liveOverview" />
    </div>
  </div>
</template>

<script>
import joinLiveRoomByLessonId from "@saas/components/src/mixins/joinLiveRoomByLessonId";
import LiveModeDialog from "./components/LiveModeDialog";
import AssistantList from "./components/AssistantList";
import TeacherList from "./components/TeacherList";
import LiveOverview from "./components/LiveOverview";
import { mapGetters } from "vuex";
import { getDiffDate, joinLiveRoom } from "@saas/components";
import moment from "moment";
import {
  getTeacherCourseList,
  getTeacherToken,
} from "@saas/service-api/src/live-list";
import { MyCalendar } from "@saas/components/src";
import { getLessonDetail } from "@saas/service-api/src/learning-center";
export default {
  mixins: [joinLiveRoomByLessonId],
  data: function () {
    return {
      pageLoading: false,
      moment,
      activeId: 0,
      navList: [
        { name: "授课老师", type: 0 },
        { name: "助教老师", type: 1 },
      ],
      teacherList: [], //授课列表
      assistantList: [], //助教列表
      activeDay: "", //当前选中日期
      activeMounth: "", //当前月份
      showAll: false, //是否展示全部
      needMarkList: [], //需要进行标记处理的数据
      page_no: 1,
      page_size: 18,
      noMore: false,
      isElectron: window.isElectron,
    };
  },
  created() {
    this.initData();
    if (window.isElectron) {
      // window.ipcRenderer.on("join-live-room-over", this.stopLoading);
      window.ipcRenderer.on("end-class", this.onEndClass);
    } else {
      // window.addEventListener("join-live-room-over", this.stopLoading, true);
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 参数liveover为1时，打开直播报告
      if (+this.$route.query.liveover === 1) {
        this.$refs.liveOverview.openDialog({
          lessonId: this.$route.query.lessonid,
          courseId: this.$route.query.courseid,
        });
      }
      this.$router.replace({
        query: {
          ...this.$route.query,
          liveover: 0,
        },
      });
    });
  },
  beforeDestroy() {
    // window.removeEventListener("join-live-room-over", this.stopLoading, true);
    // window?.ipcRenderer?.removeListener(
    //   "join-live-room-over",
    //   this.stopLoading
    // );
    window?.ipcRenderer?.removeListener("end-class", this.onEndClass);
  },
  methods: {
    initData() {
      this.activeDay = moment().format("YYYY-MM-DD");
      this.activeMounth = moment().format("YYYY-MM");
      let params = {
        type: this.activeId,
        begin_at: Math.floor(moment().startOf("month").valueOf() / 1000),
        end_at: Math.floor(moment().endOf("month").valueOf() / 1000),
        page_no: 0,
        page_size: 0,
      };
      this.apiGetCourseList(params, true, true);
    },
    // createRooming(status) {
    //   this.pageLoading = status;
    // },
    // stopLoading() {
    //   console.log("stopLoading--5");
    //   // this.pageLoading = false;
    //   this.$saasLoadingClose();
    // },
    onEndClass(event, params) {
      // 刷新当前页面
      this.initData();
      setTimeout(() => {
        this.$refs.liveOverview.openDialog({
          lessonId: params.lessonId,
          courseId: params.courseId,
        });
      }, 100);
    },
    // 监听列表滚动
    handleScroll(event) {
      if (!this.showAll || this.noMore || this.isLoading) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.isLoading = true;
        this.page_no++;
        let listName = "";
        if (this.activeId === 1) {
          listName = "assistantList";
        } else {
          listName = "teacherList";
        }
        this.getAllListBypage(listName);
      }
    },
    handleSuccess(obj) {
      this.apiGetTeacherToken(obj);
    },
    // 进入教室
    async goLiveRoom(obj) {
      const { course_id, lesson_id } = obj;
      if (course_id && lesson_id) {
        let res = await getLessonDetail({
          course_id,
          lesson_id,
        });
        if (res.code === 40007) {
          // 开启网页防火墙
          this.$router.replace("/firewall/" + course_id);
          return;
        }
        obj = { ...obj, ...res.data };
      }
      if (obj.mode) {
        // 已创建
        this.apiGetTeacherToken(obj);
      } else {
        // 未创建
        this.$refs.liveMode.openDialog(obj);
      }
    },
    apiGetTeacherToken(obj) {
      this.$saasLoadingShow();
      // this.pageLoading = true;
      let params = {
        course_id: obj.course_id,
        lesson_id: obj.lesson_id,
        is_teacher: this.user.is_teacher,
      };
      getTeacherToken(params).then((res) => {
        if (res.code === 1) {
          let {
            room_id = "",
            token = "",
            user_id = "",
            risk_control_switch,
            risk_control_config = {},
            is_lesson_teacher,
            is_lesson_assistant,
          } = res.data;
          let { course_id = "", lesson_id = "" } = obj;
          const disableRecord =
            risk_control_switch === 1 &&
            risk_control_config.recording_screen_switch === 1
              ? 1
              : 0;
          let liveParams = {
            classid: room_id,
            userid: user_id,
            courseid: course_id,
            lessonid: lesson_id,
            token: token,
            disableRecord,
            mode: obj.mode,
            isNewLive: obj.is_new_live,
            isTeacher: is_lesson_teacher,
            isAssistant: is_lesson_assistant,
          };
          // this.pageLoading = false;
          joinLiveRoom(liveParams);
        } else {
          this.$saasLoadingClose();
          // this.pageLoading = false;
          this.$message.error(res.message);
        }
      });
    },
    handleChangeMonth(data) {
      this.activeMounth = data;
      let params = {
        type: this.activeId,
        begin_at: Math.floor(
          moment(this.activeMounth).startOf("month").valueOf() / 1000
        ),
        end_at: Math.floor(
          moment(this.activeMounth).endOf("month").valueOf() / 1000
        ),
        page_no: 0,
        page_size: 0,
      };
      this.apiGetCourseList(params, true);
    },
    showAllData(type) {
      this.activeDay = "";
      this.showAll = true;
      // 清空原有展示数据
      let listName = "";
      if (this.activeId === 1) {
        listName = "assistantList";
      } else {
        listName = "teacherList";
      }
      this[listName] = [];
      this.page_no = 1;
      this.noMore = false;
      this.getAllListBypage(listName);
      let nowMounth = moment().format("YYYY-MM");
      if (nowMounth !== this.activeMounth || type === "changeTab") {
        // 获取当月数据-只进行标记
        this.handleChangeMonth(moment().format("YYYY-MM"));
      }
    },
    // 全部数据分页加载
    getAllListBypage(listName) {
      let params = {
        type: this.activeId,
        page_no: this.page_no,
        page_size: this.page_size,
      };
      getTeacherCourseList(params).then((res) => {
        console.log("res", res, "listName", listName);
        if (res.code === 1) {
          let data = this.handleLiveStatus(res.data?.list || []);
          // 过滤出未结束的课程
          // data = data.filter((item) => {
          //   return !(item.live_end_time * 1000 < new Date().getTime());
          // });
          this[listName] = this[listName].concat(data);
          if (this[listName].length === res.data.total) {
            this.noMore = true;
          }
        } else {
          this.$message.error(res.message);
        }
        this.isLoading = false;
      });
    },
    handleLiveStatus(arr) {
      arr.forEach((item) => {
        // 直播课状态处理
        this.handleLiveTimeStatus(item);
        // 处理直播间状态
        this.handleRoomStatus(item);
        // 提示信息处理
        this.handleLiveTips(item);
      });
      return arr;
    },
    handleLiveTimeStatus(item) {
      let begin = item.live_start_time;
      let end = item.live_end_time;
      let now = new Date().getTime();
      // 老师，可提前30分钟进入
      begin = begin - 30 * 60;
      if (end * 1000 < now) {
        // 已结束
        item.status = 3;
      } else if (begin * 1000 > now) {
        // 未开始
        item.status = 1;
      } else {
        // 已开始
        item.status = 2;
      }
      if (item.room_end_time > 0) {
        // 直播已经结束
        item.status = 3;
      }
    },
    // 处理直播间状态
    handleRoomStatus(item) {
      let { room_start_time, room_end_time } = item;
      if (room_start_time > 0 && !room_end_time) {
        item.roomStatus = 2;
        item.roomStatusText = "上课中";
      } else if (room_end_time > 0) {
        item.roomStatus = 3;
        item.roomStatusText = "已下课";
      } else {
        item.roomStatus = 1;
        item.roomStatusText = "未开始";
      }
    },
    // 直播课提示信息
    handleLiveTips(lesson) {
      if (lesson.record_url && lesson.is_record === 1) {
        lesson.liveStatus = 1;
        lesson.tips = "观看视频";
      } else if (lesson.roomStatus === 3 && lesson.is_record === 1) {
        lesson.liveStatus = 2;
        lesson.tips = "回放生成中";
      } else if (lesson.status === 2 || lesson.roomStatus === 2) {
        // 直播间开始上课|到后台设置的课程开始时间
        lesson.liveStatus = 3;
        lesson.tips = "开始直播";
      } else if (lesson.status === 1 && lesson.first_join_time) {
        lesson.liveStatus = 4;
        // lesson.tips = `提前${lesson.first_join_time}分钟可进入教室`;
        lesson.tips = `直播前30分钟可开启直播`;
      } else if (lesson.roomStatus === 1) {
        lesson.liveStatus = 5;
        lesson.tips = "未进行直播";
      } else if (lesson.is_record === 2) {
        lesson.liveStatus = 1;
      }
    },
    handleClickDay(data) {
      this.showAll = false;
      this.activeDay = data;
      this.handleShowList(this.needMarkList);
    },
    // 获取课程列表 params：参数；needMark：需要将得到的数据标记到日历上；handleShow：需要将得到的数据渲染到当前active列表
    apiGetCourseList(params, needMark = false, handleShow = false) {
      getTeacherCourseList(params).then((res) => {
        if (res.code === 1) {
          let data = this.handleLiveStatus(res.data?.list || []);
          // 过滤出未结束的课程
          // data = data.filter((item) => {
          //   return !(item.live_end_time * 1000 < new Date().getTime());
          // });
          if (needMark) {
            // 需要进行标记
            this.needMarkList = data;
          }
          if (handleShow) {
            // 处理要展示的数据
            this.handleShowList(data);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleShowList(arr) {
      let listName = "";
      if (this.activeId === 1) {
        listName = "assistantList";
      } else {
        listName = "teacherList";
      }
      // 展示全部
      if (this.showAll) {
        this[listName] = arr;
        return false;
      }
      // 展示某天
      let beginTime, endTime;
      if (this.activeDay) {
        beginTime = new Date(this.activeDay).setHours(0, 0, 0);
        endTime = new Date(this.activeDay).setHours(24, 0, 0) - 1000;
      }
      this[listName] = arr.filter((item) => {
        // return !(
        //   item.live_end_time * 1000 < beginTime ||
        //   item.live_start_time * 1000 > endTime
        // );
        return (
          item.live_start_time * 1000 >= beginTime &&
          item.live_end_time * 1000 <= endTime
        );
      });
      console.log(this[listName], arr, this.activeDay, beginTime, endTime);
    },
    changeTab(type) {
      this.activeId = type;
      if (this.showAll) {
        // 展示全部
        this.showAllData("changeTab");
      } else {
        // 展示activeDay
        let day = this.activeDay.slice(0, -3);
        let params = {
          type: this.activeId,
          begin_at: Math.floor(
            moment(this.activeDay).startOf("month").valueOf() / 1000
          ),
          end_at: Math.floor(
            moment(this.activeDay).endOf("month").valueOf() / 1000
          ),
          page_no: 0,
          page_size: 0,
        };
        if (day === this.activeMounth) {
          // activeDay在activeMounth
          // setTimeout(() => {
          this.apiGetCourseList(params, true, true);
          // }, 1000);
        } else {
          // activeDay不在activeMounth
          // 获取activeDay所在月份数据进行列表展示
          this.apiGetCourseList(params, false, true);
          params.begin_at = Math.floor(
            moment(this.activeMounth).startOf("month").valueOf() / 1000
          );
          params.end_at = Math.floor(
            moment(this.activeMounth).startOf("month").valueOf() / 1000
          );
          // 获取activeMounth所在月份数据-标记到日历上
          this.apiGetCourseList(params, true, false);
        }
      }
    },
  },
  computed: {
    markDate() {
      let arr = [];
      this.needMarkList.forEach((item) => {
        let stime = moment(item.live_start_time * 1000).format("YYYY-MM-DD");
        let etime = moment(item.live_end_time * 1000).format("YYYY-MM-DD");
        let diffDateArr = getDiffDate(stime, etime);
        arr = arr.concat(diffDateArr);
      });
      // 去重
      arr = Array.from(new Set(arr));
      return arr.map((item) => {
        return {
          date: item,
          className: "mark1",
        };
      });
    },
    ...mapGetters(["user"]),
  },
  components: {
    "my-calendar": MyCalendar,
    "assistant-list": AssistantList,
    "teacher-list": TeacherList,
    "live-mode-dialog": LiveModeDialog,
    "live-overview": LiveOverview,
  },
};
</script>

<style lang="scss" scoped>
.live-list {
  min-height: calc(100vh - 110px);
  width: 100%;
  .tabs-wrap {
    display: flex;
    align-items: center;
    height: 46px;
    background: var(--card-bg, #ffffff);
    border-radius: 16px;
    margin-bottom: 17px;
    padding: 0 40px;
    li {
      cursor: pointer;
      font-size: 16px;
      color: var(--text-secondary, #515350);
      line-height: 22px;
      padding: 0 5px;
      margin-right: 40px;
    }
    .active {
      position: relative;
      font-weight: 600;
      font-size: 16px;
      color: var(--text-primary, #{$saas-text-color});
      line-height: 22px;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: -8px;
        transform: translateX(-50%);
        width: 19px;
        height: 4px;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 3px;
      }
    }
  }
  .live-list-cont {
    display: flex;
  }
  .calendar {
    width: 330px;
    margin-right: 20px;
  }
  .right-cont {
    flex: 1;
  }
  // 列表公共样式
  ::v-deep .list-comp {
    height: 100%;
    .el-empty {
      height: 80%;
    }
  }
  ::v-deep .list-comp .live-list-wrap {
    max-height: calc(100vh - 175px);
    overflow-y: auto;
    .live-item {
      display: flex;
      align-items: center;
      padding-bottom: 20px;
      position: relative;
      &::after {
        position: absolute;
        left: 4px;
        top: 50%;
        display: block;
        content: "";
        width: 1px;
        height: 122px;
        background: var(--border-color, #e5e6eb);
      }
    }
    .live-item:last-child {
      &::after {
        display: none;
      }
    }
    .time-axis {
      width: 95px;
      padding-left: 18px;
      position: relative;
      font-weight: 500;
      font-size: 16px;
      color: var(--text-primary, #333333);
      &::after {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        display: block;
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      }
    }
    .live-card {
      flex: 1;
      display: flex;
      align-items: center;
      width: 600px;
      height: 122px;
      background: var(--card-bg, #ffffff);
      border-radius: 24px;
      cursor: pointer;
      padding: 0 16px;

      .cover {
        width: 160px;
        height: 90px;
        margin-right: 12px;
        object-fit: cover;
        border-radius: 16px;
      }
      .live-info {
        width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 90px;
        .name {
          font-weight: 500;
          font-size: 18px;
          color: var(--text-primary, #{$saas-text-color});
          line-height: 28px;
          margin-bottom: 8px;
        }
        .course-name,
        .unit-name {
          font-weight: 400;
          font-size: 14px;
          color: var(--text-secondary, #747573);
          line-height: 20px;
        }
        .course-name {
          margin-bottom: 4px;
        }
        .name,
        .course-name,
        .unit-name {
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .name {
          margin-bottom: 8px;
        }
      }
      .operate-wrap {
        width: 90px;
        text-align: right;
        margin-right: 5px;
        .status {
          font-weight: 400;
          font-size: 15px;
          color: var(--text-primary, #0d1400);
          line-height: 21px;
          &.tips-text {
            font-weight: 400;
            font-size: 15px;
            color: var(--text-secondary, #747573);
            line-height: 21px;
            &.red {
              color: #f03349;
            }
          }
        }
        .join-live-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100px;
          height: 30px;
          background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
          border-radius: 15px;
          img {
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 18px;
          -webkit-text-fill-color: #fff;
        }
      }
    }
  }
  ::v-deep .list-comp .live-list-wrap {
    padding-right: 10px;
  }
  ::v-deep .list-comp .live-list-wrap::-webkit-scrollbar {
    width: 7px;
  }
  ::v-deep .list-comp .live-list-wrap::-webkit-scrollbar-thumb {
    background: var(--scrollbar-thumb-bg, #c1c1c1);
    border-radius: 4px;
  }
}

// 客户端
.electron-live-list.live-list {
  .tabs-wrap {
    display: flex;
    align-items: center;
    height: auto;
    background: transparent;
    border-radius: 0;
    margin-bottom: 15px;
    padding: 10px;
    li {
      cursor: pointer;
      font-size: 14px;
      color: var(--text-secondary, #515350);
      line-height: 20px;
      padding: 0;
      margin-right: 36px;
    }
    .active {
      font-weight: 500;
      font-size: 14px;
      color: var(--text-primary, #0d1400);
      line-height: 20px;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: -4px;
        transform: translateX(-50%);
        width: 12px;
        height: 3px;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 3px;
      }
    }
  }
  ::v-deep .calendar {
    width: 300px;
    margin-right: 15px;
    #comp_calender {
      width: 300px;
      .wh_content_item {
        font-size: 14px;
      }
    }
  }
  .right-cont {
    ::v-deep .list-comp .live-list-wrap {
      .live-item {
        padding-bottom: 12px;
        &::after {
          height: 100px;
        }
      }
      .time-axis {
        width: 80px;
        padding-left: 14px;
        font-size: 14px;
      }
      .live-card {
        width: calc(100% - 65px);
        height: 102px;
        border-radius: 16px;
        padding: 0 20px 0 12px;

        .cover {
          width: 142px;
          height: 80px;
          margin-right: 8px;
          object-fit: cover;
          border-radius: 16px;
        }
        .live-info {
          height: 80px;
          .name {
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 6px;
          }
          .course-name,
          .unit-name {
            font-size: 12px;
            line-height: 17px;
          }
          .course-name {
            margin-bottom: 4px;
          }
        }
      }
    }
  }
}

.live-list {
  .tabs-wrap {
    background: var(--card-bg, #ffffff);
    color: var(--text-primary, #0d1400);
  }
}
</style>
<style>
.el-loading-spinner {
  font-size: 40px !important;
  z-index: 99;
}
.el-loading-spinner .el-loading-text {
  font-size: 15px !important;
  font-weight: 700 !important;
}
</style>
